<ng-container *ngIf="thesaurusFieldDefinition && (conceptUri$ | async)">
    <span class="sh-icon-label">
        <ng-container
            *ngTemplateOutlet="uriFieldDefinition ? searchableData : labelOnly; context: { uri: conceptUri$ | async, fieldDefinition: uriFieldDefinition }"
        >
        </ng-container>
        <a
            id="openDialogIcon"
            [title]="'thesaurus.show-concept' | translate"
            class="sh-icon-label__icon sh-link -sh-superscript"
            (click)="showConceptDetails($event)"
        >
            <svg sh-icon [size]="'small'" aria-hidden="true" [name]="'info'"></svg>
        </a>
    </span>
</ng-container>

<ng-template #searchableData let-uri="uri" let-fieldDefinition="fieldDefinition">
    <a [title]="label" [routerLink]="routerLink" [queryParams]="getSearchRouterParams(fieldDefinition, uri)" class="sh-link">{{ label }}</a>
</ng-template>

<ng-template #labelOnly>{{ label }}</ng-template>
